import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./index.css";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (sentryDsn) {
  const isProd = import.meta.env.MODE === "production";
  const rawSample = import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE as
    | string
    | undefined;
  const parsedSample = rawSample === undefined ? NaN : Number(rawSample);
  const tracesSampleRate = Number.isFinite(parsedSample)
    ? Math.min(1, Math.max(0, parsedSample))
    : isProd
      ? 0.1
      : 0;
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE as string | undefined,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate,
    sendDefaultPii: false,
  });
}

function FallbackError() {
  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-background p-6 text-center">
      <div className="max-w-md space-y-3">
        <h1 className="text-xl font-semibold">Une erreur est survenue</h1>
        <p className="text-sm text-muted-foreground">
          Nous avons été notifiés et travaillons à corriger le problème.
          Rechargez la page pour réessayer.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground"
        >
          Recharger
        </button>
      </div>
    </div>
  );
}

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<FallbackError />} showDialog={false}>
    <App />
  </Sentry.ErrorBoundary>,
);
